<canvas #confetticanvas class="confetti-canvas"></canvas>